import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { AppProfile } from 'src/app/shared/app-profile/app-profile';

@Injectable({
  providedIn: 'root'
})
export class AccessoryCreateService {
  private apiUrl =  this.appProfile.ampmUs+'/ems/fhir/'+this.appProfile.org+'/Device';
  private headers = new HttpHeaders({
    'X-tenant-Id': this.appProfile.tenant,
    'api-version': '1.0.0',
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${this.authService.accessToken}`,
  });

  typeCodingCodeMapping = {
    "Cushion": "257420000",
    "Headgear": "257418007",
    "Mask": "257419004",
    "BreathingCircuit": "706173004"
  };
  
  constructor(private http: HttpClient, private authService: AuthService, private appProfile: AppProfile) { }

  createAccessory(displayName: string, serialNumber: string, accessoryType: string, detail: string): Observable<any> {
    let measureUnit = 'type';
    let measureUnitvalue = detail.toLowerCase();
    if (accessoryType !== 'BreathingCircuit') {
        measureUnit = 'size';
        measureUnitvalue = detail.toLowerCase().slice(0, 1);
    }
    const payload = {
      resourceType: 'Device',
      meta: {
        profile: [
          'https://www.fhir.philips.com/4.0/uv/ampm/StructureDefinition/Ampm' + accessoryType + 'Accessory'
        ]
      },
      status: 'active',
      manufacturer: 'Philips',
      manufactureDate: '2000-04-03',
      expirationDate: '2022-04-05',
      serialNumber: serialNumber,
      deviceName: [
        { name: accessoryType, type: 'user-friendly-name' },
      ],
      modelNumber: 'A1-FXAC1193',
      type: {
        coding: [
          {
            system: 'https://snomed.info/sct',
            code: this.typeCodingCodeMapping[accessoryType],
            display: accessoryType,
          }
        ]
      },
      property: [
        {
          type: {
            coding: [
              {
                code: accessoryType.toLowerCase() + '.' + measureUnit,
                system: 'https://www.fhir.philips.com/4.0/uv/ampm/CodeSystem/AmpmDeviceAccessoryPropertiesValuesCodeSystem',
                display: displayName
              }
            ]
          },
          valueCode: [
            {
              coding: [
                {
                  code: accessoryType.toLowerCase() + '.' + measureUnit + '.' + measureUnitvalue,
                  system: 'https://www.fhir.philips.com/4.0/uv/ampm/CodeSystem/AmpmDeviceAccessoryPropertiesValuesCodeSystem',
                  display: detail
                }
              ]
            }
          ]
        }
      ],
      extension: [
        {
          url: 'https://www.fhir.philips.com/4.0/uv/ampm/StructureDefinition/AmpmAccessoryResupplyEligibilityDateExtension',
          valueDateTime: '2022-08-08T02:01:40+00:00'
        }
      ]
    };

    return this.http.post(this.apiUrl, payload, { headers: this.headers });
  }
}
